<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import axios from 'axios'
import Stat from '@components/widget-stat'
import $ from 'jquery';

export default {
	page: {
		title: 'Saran dan Laporan',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: {
    Stat,
		VuePerfectScrollbar,
		Layout
	},
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods: {
    sendSuggestion: function(e) {
      let self = this;
      this.$swal({
        icon: 'warning',
        html: 'Apakah anda yakin untuk mengirimkannya?',
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
      }).then((result) => {
        if (result.isConfirmed) {
          self.sendSuggestionConfirmed();
        } 
      });

    },
    sendSuggestionConfirmed: function(e) {
      var payload = {
        contentType : this.data.contentType,
        content : this.data.content
      };

      axios({
        method: 'post',
        data: payload,
        url: 'homescreen'
      }).then(response => {
        if (response.status === 200) {
          this.$router.push('/dashboard'); 
          this.$swal({
            icon: 'success',
            html: 'Data terkirim!',
            showCloseButton: false,
            focusConfirm: true,
            confirmButtonText: 'Oke',
          }).then((result) => {
          });
        } 
      }, error => {
        this.$bvToast.toast('Error', {
          title: 'Information',
          variant: 'danger'
        })
      });
    },
  },
  created() {
    this.data.contentType = 'Bug';
  },
  mounted() {
  },
	data() {
    return {
      data : []
		}
	},
}
</script>

<template>
	<Layout>
		<div class="row page-title align-items-center mt-3">
			<div class="col-sm-12 col-xl-12">
				<h4 class="mb-1 mt-0">Saran dan Laporan</h4>
			</div>

      <div class="col-sm-12 col-xl-6 mt-3">
        <div class="card">
          <div class="card-body">
            <b-form class="form-horizontal">
              <div class="row">
                <div class="col">

                  <div class="form-group row">
                    <label class="col-lg-2 col-form-label">Tipe</label>
                    <div class="col-lg-10">
                      <select class="form-control custom-select" v-model="data.contentType">
                        <option value="Sugesti">Sugesti</option>
                        <option value="Saran">Saran</option>
                        <option value="Bug">Bug / Kesalahan Sistem</option>
                        <option value="Account">Masalah Akun</option>
                      </select>
                    </div>
                  </div>

                  <b-form-group
                    label-cols-sm="10"
                    label-cols-lg="2"
                    label="Laporan"
                    label-for="input-content"
                  >
                    <b-form-input
                      id="input-content"
                      v-model="data.content"
                      placeholder="Laporan"
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </b-form>

            <b-form-group
              label-cols-sm="10"
              label-cols-lg="2"
              label=""
              label-for="input-content"
            >
              <button class="btn btn-primary" @click="sendSuggestion()"><i class="uil uil-send"></i> Kirim</button>
            </b-form-group>

          </div>
          <!-- end card-body -->
        </div>
        <!-- end card-->
        <!-- end col -->
      </div>

		</div>
	</Layout>
</template>